"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsbarcode_1 = __importDefault(require("jsbarcode"));
var react_1 = __importStar(require("react"));
var Barcode = /** @class */ (function (_super) {
    __extends(Barcode, _super);
    function Barcode(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBarcode = function (r) {
            _this.barcode = r;
        };
        _this.barcode = react_1.default.createRef();
        return _this;
    }
    Barcode.prototype.componentDidMount = function () {
        this.update();
    };
    Barcode.prototype.componentDidUpdate = function () {
        this.update();
    };
    Barcode.prototype.update = function () {
        var _a = this.props, value = _a.value, options = _a.options // see all options from https://github.com/lindell/JsBarcode/wiki
        ;
        try {
            (0, jsbarcode_1.default)(this.barcode, value, options);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    };
    Barcode.prototype.render = function () {
        var id = this.props.id;
        return react_1.default.createElement("svg", { id: id, ref: this.handleBarcode });
    };
    return Barcode;
}(react_1.Component));
exports.default = Barcode;
//# sourceMappingURL=Barcode.js.map